import { IUsuarioRegistrarModel } from "../interfaces/seguridad/IUsuarioRegistrarModel";
import { UsuarioRegistrarModel } from "./UsuarioRegistrarModel";

export class SessionModel {
    public token: string;
    public user: IUsuarioRegistrarModel;
    constructor(){
        this.token = '';
        this.user = new UsuarioRegistrarModel();
    }
  }